import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { TextareaAutosize, Paper, Tooltip } from '@material-ui/core'
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker'
import { Phone } from "@material-ui/icons";
//import AddPinCode from "./AddPinCode";
import ModalFrame from "../../biztran_controls/Modal_Frame";
// import AddMultiple from "./AddMultiple";

const todate = new Date()
const NextFollowupDate = todate.getFullYear() - 1 + '/04/01';
var flag = true;
const CreateEmployeeMaster = (props) => {
  debugger;
  const classes = useStyles();
  const [Mode, setMode] = useState("");
  //const [POCID, setPOCID] = useState({ id:props.POCID });
  const [EmpID, setEmpID] = useState('');
  const [EmpCode, setEmpCode] = useState('');
  const [EmpName, setEmpName] = useState('');
  const [EmpPassword, setEmpPassword] = useState('');
  const [EmailPassword, setEmailPassword] = useState('');
  const [CategoryID, setCategoryID] = useState('');
  const [CatID, setCatID] = useState('');
  // const [CallDate,setCallDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  // const [EmpID, setEmpID] = useState('');
  const [MobileNo, setMobileNo] = useState('');
  const [Address, setAddress] = useState('');
  const [BankAccountName, setBankAccountName] = useState('');
  const [BankName, setBankName] = useState('');
  const [BankBranch, setBankBranch] = useState('');
  const [IFSCCode, setIFSCCode] = useState('');
  const [IsActive, setIsActive] = useState(null);
  const [CreatedByID, setCreatedByID] = useState(sessionStorage.UserName);
  const [CreatedOn, setCreatedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [ModifiedByID, setModifiedByID] = useState(sessionStorage.UserName);
  const [ModifiedOn, setModifiedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [EmailID, setEmailID] = useState('');
  const [Categorycmb, setCategorycmb] = useState([]);
  const [Catcmb, setCatcmb] = useState([]);
  // const [Categorycmb, setCategorycmb] = UseFetchData({});
  const [ApprovedID, setApprovedID] = useState('');
  const [CategoryDataResponse, fetchCategoryData] = UseFetchData();
  const [EmpDataResponse, fetchEmpData] = UseFetchData();
  const [responseState, fetchStateData] = UseFetchData();
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [response, fetchData] = UseFetchData();
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  // const [IsActive, setIsActive] = useState(null);
  const [chkIsActive, setchkIsActive] = useState(false);
  const [chkIsActive1, setchkIsActive1] = useState(false);
  const [chkIsActive2, setchkIsActive2] = useState(false);
  const [responseGetData, fetchDataGetData] = UseFetchData();
  //const [State, setState] = useState([]);
  const [StateOptions, setStateOptions] = useState([]);
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Count, setCount] = useState();
  //const [ComboDataResponse, fetchReasonCodeData] = UseFetchData();
  const [responseContDtls, fetchContDtls] = UseFetchData();
  const [responseContByIDDtls, fetchContByIDDtls] = UseFetchData();
  const [isOpenProduct, setOpenProduct] = useState(false);
  const [Empcmb, setEmpcmb] = useState([]);
  const [responseCombo, fetchComboData] = UseFetchData();

  const ref = useRef(null);

  const [label, setlabel] = useState(false);
  const [label01, setlabel01] = useState(false);
  const [label02, setlabel02] = useState(false);
  const [label03, setlabel03] = useState(false);
  const [label04, setlabel04] = useState(false);
  const [label05, setlabel05] = useState(false);
  const [label06, setlabel06] = useState(false);
  const [label07, setlabel07] = useState(false);


  // const validationSchema = Yup.object({
  //   EmpCode: Yup.string().required("Required!"),
  //   // NoOfEmp: Yup.number().required("Required!"),
  //   MobileNo: Yup.string().required("Required!"),
  //   EmailID: Yup.string().required("Required!"),
  // });


  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const onSubmit = (values) => {
    debugger;
    var mnc;
    if (chkIsActive === true) {
      mnc = '1';
    }
    else {
      mnc = '0';
    }
    // var mnc1;
    // if (chkIsActive1 === true) {
    //   mnc1 = 'True';
    // }
    // else {
    //   mnc1 = 'False';
    // }
    // var mnc2;
    // if (chkIsActive2 === true) {
    //   mnc2 = 'True';
    // }
    // else {
    //   mnc2 = 'False';
    // }
    var UpdatedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    //debugger;
    bodyFormData.append("EmpID", props.EmpID);
    if (EmpCode !== null && EmpCode !== "") {
      bodyFormData.append("EmpCode", values.EmpCode);
    }
    else {
      //setTitleText = (true)
      setlabel(true)
      return;
    }
    if (EmpName !== null && EmpName !== "") {
      bodyFormData.append("EmpName", values.EmpName);
    }
    else {
      //setTitleText = (true)
      setlabel(true)
      return;
    }
    if (EmpPassword !== null && EmpPassword !== "") {
      bodyFormData.append("EmpPassword", values.EmpPassword);
    }
    else {
      //setTitleText = (true)
      setlabel(true)
      return;
    }
    if (CategoryID !== null && CategoryID !== "") {
      bodyFormData.append("CategoryID", values.CategoryID);
    }
    else {
      //setTitleText = (true)
      setlabel(true)
      return;
    }
    if (ApprovedID !== null && ApprovedID !== "") {
      bodyFormData.append("ApproverID", values.ApprovedID);
    }
    else {
      //setTitleText = (true)
      setlabel(true);
      return;
    }
    // if (MobileNo !== null && MobileNo !== "") {
    bodyFormData.append("MobileNo", values.MobileNo);

    // }
    // else {
    //   //setTitleText = (true)
    //   setlabel(true)
    //   return;
    // }
    // if (EmailID !== null && EmailID !== "") {
    bodyFormData.append("EmailID", values.EmailID);
    bodyFormData.append("EmailPassword", values.EmailPassword);
    // }
    // else {
    //   //setTitleText = (true)
    //   setlabel(true)
    //   return;
    // }



    // if (Address !== null && Address !== "") {
    bodyFormData.append("Address", values.Address);
    // }
    // else {
    //   //setTitleText = (true)
    //   setlabel(true)
    //   return;
    // }
    bodyFormData.append("BankAccountName", values.BankAccountName);

    bodyFormData.append("BankName", values.BankName);
    bodyFormData.append("BankBranch", values.BankBranch);
    bodyFormData.append("IFSCCode", values.IFSCCode);
    bodyFormData.append("IsActive", mnc);
    bodyFormData.append("ByID", UpdatedByID);


    fetchData("Primary/SaveEmployee", bodyFormData);
  };


  // const handleOpenModal = () => {
  //   //debugger;
  //   setOpenProduct(true);
  // };
  // const onToClear = () => {
  //   setToDate();
  //   setdefaultToDate();
  // }

  // const ApproverOPtion = [
  //   { key: "Manager", value: "bd223d43-4589-11ed-ad55-42010aa00007" },
  //   // { key: "Out Warranty", value: "Out Warranty" },

  // ];
  // const ApproverData = () => {
  //   let ApproverCombo = ApproverOPtion.map((data) =>
  //     <option key={data.key} value={data.value}>
  //       {data.key}
  //     </option>
  //   );
  //   setApprovercmb(ApproverCombo);
  // };
  // let Approvercmb = ApproverData();

  // useEffect(() => {
  //   //debugger;
  //   ApproverData(responseCombo);
  // }, [responseCombo])



  const GetByIDData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("EmpID", props.EmpID);
    //bodyFormData.append("LeadID", props.LeadID);
    //bodyFormData.append("ServiceCentreCode", ServiceCentreCode);
    fetchDataGetData("Primary/GetByEmployeeID", bodyFormData);
  };
  useEffect(() => {
    //debugger;
    // GetComboData();
    GetByIDData(props.EmpID);
    if (EmpID !== "") {
      GetByIDData();
    }
    //GetByIDData();
    console.log("EmpID", EmpID)
  }, []);

  const onCheck = (e) => {
    //debugger;
    setchkIsActive(e.target.checked);
    console.log(isChecked);
  };
  const onCheckChange1 = (e) => {
    //debugger;
    setIsChecked1(e.target.checked);
    console.log(isChecked1);
  };
  const onCheckChange2 = (e) => {
    //debugger;
    setIsChecked2(e.target.checked);
    console.log(isChecked2);
  };


  const PopulateEmpdata = () => {
    debugger;
    var bodyFormData = new FormData();
    fetchEmpData("Primary/cmbEmp", bodyFormData);
  }

  const EmpData = (options) => {
    debugger;
    if (options !== undefined) {
      let EmpName = options.map((data) => (
        <option key={data.EmpName} value={data.EmpID}>
          {data.EmpName}
        </option>
      ));
      setEmpcmb(EmpName);
    }
  };

  const PopulateCategorydata = () => {
    var bodyFormData = new FormData();
    fetchCategoryData("Primary/ComboData", bodyFormData);
  }

  const CategoryData = (options) => {
    //debugger;
    if (options !== undefined) {
      let Category = options.map((data) => (
        <option key={data.Category} value={data.CategoryID}>
          {data.Category}
        </option>
      ));
      setCategorycmb(Category);
    }
  };

  const CatData = React.useCallback((options) => {
    if (options !== undefined) {
      let Category = options.map((data) => (
        <option key={data.Category} value={data.CategoryID}>
          {data.Category}
        </option>
      ));
      setCatcmb(Category);
    }
  }, []);


  useEffect(() => {
    debugger;
    if (CategoryDataResponse !== undefined) {
      if (CategoryDataResponse["Category"] !== undefined) {
        CategoryData(CategoryDataResponse["Category"]);
      }
      if (CategoryDataResponse["Empcmb"] !== undefined) {
        EmpData(CategoryDataResponse["Empcmb"]);
      }
      if (CategoryDataResponse["Cat"] !== undefined) {
        CatData(CategoryDataResponse["Cat"]);
      }
    }
  }, [CategoryDataResponse]);

  useEffect(() => {
    debugger;
    if (EmpDataResponse !== undefined) {

      if (EmpDataResponse !== undefined) {
        EmpData(EmpDataResponse);
      }
    }
  }, [EmpDataResponse]);

  useEffect(() => {
    PopulateCategorydata();
    PopulateEmpdata();
  }, [])

  const populatepopupdata = () => {
    var bodyFormData = new FormData();

  }
  useEffect(() => {
    if (flag === true) {
      flag = true;
    }
    populatepopupdata();
  }, [])

  const onSelectChange = (e) => {
    // debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "CatID") {
        setCatID(targetvalue);
      }
    }
  }


  // const onCheck = (e) => {
  //   //debugger;
  //   let targetvalue = e.target.value;
  //   let targetname = e.target.name;

  //   console.log(targetvalue);
  //   if (targetvalue !== "") {
  //     if (targetname === "chkIsActive") {
  //       setchkIsActive(targetvalue);
  //     }

  //   }
  // }

  useEffect(() => {
    debugger;
    if (props.EmpID !== '') {
      setMode('Update');
    }
    else {
      setMode('Insert');
    }
    if (responseGetData !== undefined && responseGetData.length > 0 && Mode === "Update") {
      debugger;
      setEmpID(responseGetData[0].id);
      setEmpCode(responseGetData[0].EmpCode);
      setEmpName(responseGetData[0].EmpName);
      setEmpPassword(responseGetData[0].EmpPassword);
      setCategoryID(responseGetData[0].CategoryID);
      setCatID(responseGetData[0].catID);
      setAddress(responseGetData[0].Address);
      setApprovedID(responseGetData[0].ApproverID);
      setBankAccountName(responseGetData[0].BankAccountName);
      setBankName(responseGetData[0].BankName);
      setBankBranch(responseGetData[0].BankBranch);
      setIFSCCode(responseGetData[0].IFSCCode);
      setCreatedByID(responseGetData[0].CreatedByID);
      setEmailID(responseGetData[0].EmailID);
      setEmailPassword(responseGetData[0].EmailPassword);
      setMobileNo(responseGetData[0].MobileNo === "null" ? "" : responseGetData[0].MobileNo);
      setCreatedOn(responseGetData[0].CreatedOn);
      setModifiedByID(responseGetData[0].ModifiedByID);
      setModifiedOn(responseGetData[0].ModifiedOn);
      // setchkIsActive(responseGetData[0].chkIsActive);
      // setEmpcmb(responseGetData[0].EmpID);
      // setEmpID(responseGetData[0].EmpID);
      // setEmpName(responseGetData[0].EmpName);
      // setchkIsActive1(responseGetData[0].chkIsActive1);
      // setchkIsActive2(responseGetData[0].chkIsActive2);
      //setIsActive(responseGetData[0].IsActive);
      debugger;
      if (responseGetData[0].IsActive === '1') {

        setchkIsActive(true);
      } else {
        setchkIsActive(false);
      }
      // if (responseGetData[0].IsActive1 === true) {
      //   setchkIsActive1(tru
      // }
      // if (responseGetData[0].IsActive2 === true) {
      //   setchkIsActive2(true);
      // }

      //setLeadContactID(responseGetData[0].LeadContactID === null ? "" : responseGetData[0].LeadContactID);    
    }
  }, [responseGetData]);


  // useEffect(() => {
  //   PopulateData();
  // }, [])

  useEffect(() => {
    debugger;
    if (response.Response === true) {
      alert("Data Saved Succesfully.");
      //props.setRequestPOCOpen(false);
      props.setOpen(false);
      props.PopulateData();
    }
    else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);


  return (
    <div>
      <Formik
        initialValues={{
          ApprovedID: ApprovedID, CatID: CatID, EmpCode: EmpCode, EmpName: EmpName, Address: Address, EmpPassword: EmpPassword, CategoryID: CategoryID, BankAccountName: BankAccountName, BankName: BankName, BankBranch: BankBranch, IFSCCode: IFSCCode,
          EmailID: EmailID, EmailPassword: EmailPassword, CreatedByID: CreatedByID, CreatedOn: CreatedOn, MobileNo: MobileNo, ModifiedByID: ModifiedByID, ModifiedOn: ModifiedOn, IsActive: IsActive, chkIsActive2: chkIsActive2, chkIsActive1: chkIsActive1, chkIsActive: chkIsActive
        }}
        // validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid item xs={12} spacing={1} container direction="row">
                <Grid item xs={12} spacing={1} container direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"EmpCode"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Emp Code"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="EmpCode"
                      ref={ref}
                      value={EmpCode}
                      // options={Branchcmb}
                      // disabled={true}
                      onChange={(e) => {
                        setEmpCode(e.target.value)
                        handleChange()
                      }}
                    />
                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>
                  <Grid item xs={2}>
                    <label
                      htmlFor={"EmpPassword"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Emp Password"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="Password"
                      name="EmpPassword"
                      ref={ref}
                      value={EmpPassword}
                      // options={RMcmb}                   
                      onChange={(e) => {
                        setEmpPassword(e.target.value)
                        handleChange()
                      }}
                    />
                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>
                </Grid>
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"EmpName"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Emp Name"}
                    </label>
                  </Grid>
                  <Grid item xs={10} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="EmpName"
                      ref={ref}
                      value={EmpName}
                      //options={ASIcmb}                   
                      onChange={(e) => {
                        setEmpName(e.target.value)
                        handleChange()
                      }}
                    />
                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>

                </Grid>
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"EmailID"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Email"}
                    </label>
                  </Grid>
                  <Grid item xs={10} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="EmailID"
                      ref={ref}
                      value={EmailID}
                      // options={SEcmb}                  
                      onChange={(e) => {
                        setEmailID(e.target.value)
                        handleChange()
                      }}
                    />
                    {/* {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    } */}
                  </Grid>
                </Grid>
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"MobileNo"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Email Password"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="Password"
                      name="EmailPassword"
                      ref={ref}
                      value={EmailPassword}
                      // disabled={true}
                      onChange={(e) => {
                        setEmailPassword(e.target.value)
                        handleChange()
                      }}
                    />
                    { }
                  </Grid>
                  <Grid item xs={2}>
                    <label
                      htmlFor={"MobileNo"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Mobile No"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="MobileNo"
                      ref={ref}
                      value={MobileNo}
                      // disabled={true}
                      onChange={(e) => {
                        setMobileNo(e.target.value)
                        handleChange()
                      }}
                    />
                    { }
                  </Grid>

                  <Grid item xs={2}>
                    <label
                      htmlFor={"CategoryID"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Category"}
                    </label>
                  </Grid>
                  <Grid item xs={10} >
                    <BiztranControlsFormik
                      control="select"
                      name="CategoryID"
                      // ref={ref}
                      value={CategoryID}
                      options={Categorycmb}
                      onChange={(e) => {
                        setCategoryID(e.target.value)
                        // handleChange()
                      }}
                    />
                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>
                </Grid>
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"Address"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Address"}
                    </label>
                  </Grid>
                  <Grid item xs={10} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="Address"
                      ref={ref}
                      value={Address}
                      // disabled={true}
                      onChange={(e) => {
                        setAddress(e.target.value)
                        handleChange()
                      }}
                    />
                    {/* {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    } */}
                  </Grid>
                  {/* <Grid item xs={2}>
                  <label
                    htmlFor={"Category"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Category"}
                  </label>
                </Grid> */}
                  {/* <Grid item xs={2} >
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="select"
                    type="text"
                    name="Category"
                    ref={ref}
                    value={Phone}
                    // disabled={true}
                    onChange={(e) => {
                      setPhone(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid> */}
                </Grid>
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"ApprovedID"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Approver"}
                    </label>

                  </Grid>


                  <Grid item xs={10}>
                    <BiztranControlsFormik
                      control="select"
                      name="ApprovedID"
                      // ref={ref}
                      options={Empcmb}
                      onChange={(e) => {
                        setApprovedID(e.target.value)
                        // handleChange()
                      }}
                    />

                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>



                </Grid>
                {/* //new one
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"ApprovedID"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Approver"}
                    </label>

                  </Grid>


                  <Grid item xs={10}>
                    <BiztranControlsFormik
                      control="select"
                      name="CatID"
                      options={Catcmb}
                      onChange={onSelectChange}
                    />

                    {label == true ?
                      <label
                        htmlFor={"*"}
                        style={{
                          display: "block",
                          width: "100%",
                          color: 'red',
                          marginTop: -25,
                          marginLeft: -15,
                          fontSize: 15,
                        }}
                      >
                        {"*"}
                      </label>
                      : null
                    }
                  </Grid>



                </Grid> */}
                <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                  <Grid item xs={2}>
                    <label
                      htmlFor={"BankAccountName"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Bank Account Number"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="BankAccountName"
                      ref={ref}
                      value={BankAccountName}
                      //  disabled={true}
                      onChange={(e) => {
                        setBankAccountName(e.target.value)
                        handleChange()
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <label
                      htmlFor={"BankName"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Bank Name"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="BankName"
                      ref={ref}
                      value={BankName}
                      //  disabled={true}
                      onChange={(e) => {
                        setBankName(e.target.value)
                        handleChange()
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} spacing={1} container direction="row" >
                  <Grid item xs={2} >
                    <label
                      htmlFor={"BankBranch"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Bank Branch"}
                    </label>
                  </Grid>
                  <Grid item xs={4}>
                    <BiztranControlsFormik
                      control="input"
                      name="BankBranch"
                      ref={ref}
                      //value={State}
                      options={BankBranch}
                      //onChange={onSelectChange}
                      onChange={(e) => setBankBranch(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <label
                      htmlFor={"IFSCCode"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"IFSC Code"}
                    </label>
                  </Grid>
                  <Grid item xs={4} >
                    <BiztranControlsFormik
                      autoFocus="autofocus"
                      control="input"
                      type="text"
                      name="IFSCCode"
                      ref={ref}
                      // value={City}
                      options={IFSCCode}
                      onChange={(e) => {
                        setIFSCCode(e.target.value)
                        handleChange()
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} spacing={1} container direction="row" >
                  <Grid item xs={0.4} style={{ paddingLeft: 0.1 }}>
                    <label htmlFor={"IsActive"}
                      style={{
                        display: 'block', width: '100%'
                      }}>
                      {"IsActive"}
                    </label>
                  </Grid>
                  <Grid item xs={3}>
                    <BiztranControlsFormik
                      control='input'
                      type='checkbox'
                      name='chkIsActive'
                      //value={true}
                      onChange={onCheck}
                    />
                  </Grid>

                </Grid>
                <Grid item xs={12} spacing={1} container direction="row">

                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >

                    <BiztranControls.Button
                      text="SAVE"
                      type="submit"
                      startIcon={<SaveIcon />}
                      style={{ width: "12%" }}

                    />
                    <BiztranControls.Button
                      text="CLOSE"
                      startIcon={<CloseIcon />}
                      //startIcon={<SearchIcon />}
                      onClick={() => {
                        props.setOpen(false);
                      }}
                    />
                  </div>
                </div>
              </Grid>

            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    //marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",

    //borderRadius: "1rem",
  },
}));

export default CreateEmployeeMaster;

